import ICarSimInputData from "../Model/ICarSimInputData";
import CarSimProps from '../Model/ICarSimOutputData';
import axios from 'axios';
import { DateTime } from "luxon";
//import Config from "../ConfigComponent";
//import { UseConfigContext } from '../ConfigContext';

const CarSimService = async (carParam: ICarSimInputData, url: string) => {

  try {
    const { data } = await axios.post<CarSimProps>(url, carParam,
      {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }
      },
    );
    return data;
  }
  catch (error)
  {
    if (axios.isAxiosError(error))
    {
      //console.log('error message: ', error.message);
      return error.message;
    }
    else
    {
      //console.log('unexpected error: ', error);
      return 'An unexpected error occurred';
    }
  }
}

export default CarSimService;